module.exports = __webpack_public_path__ + "img/Geely.8178e540.png";